<div class="invoice_details invoice_details_b2b">

	<div class="close_add_item_block">
		<div class="back_to_invoice close_invoice_details" (click)="backToInvoice()" >
			<svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 24 18" fill="none">
				<path d="M10.7304 17.3118C10.4304 17.6118 10.0235 17.7803 9.59922 17.7803C9.17496 17.7803 8.76806 17.6118 8.46802 17.3118L1.26802 10.1118C0.968065 9.81177 0.799561 9.40488 0.799561 8.98061C0.799561 8.55635 0.968065 8.14946 1.26802 7.84942L8.46802 0.649416C8.76978 0.357962 9.17395 0.196692 9.59346 0.200336C10.013 0.203983 10.4143 0.372252 10.7109 0.668905C11.0076 0.965559 11.1759 1.36686 11.1795 1.78637C11.1831 2.20589 11.0219 2.61005 10.7304 2.91181L6.39922 7.38062L21.5992 7.38062C22.0236 7.38062 22.4305 7.54919 22.7306 7.84924C23.0306 8.1493 23.1992 8.55627 23.1992 8.98061C23.1992 9.40496 23.0306 9.81193 22.7306 10.112C22.4305 10.412 22.0236 10.5806 21.5992 10.5806L6.39922 10.5806L10.7304 15.0494C11.0304 15.3495 11.1989 15.7564 11.1989 16.1806C11.1989 16.6049 11.0304 17.0118 10.7304 17.3118Z" fill="#1AACD9"/>
			</svg>
			<ng-container i18n="@@invoices.back_to_all_invoice">Back to all invoices</ng-container>
		</div>
	</div>

	<div class="invoice_details_block">
		<div class="topNotification" *ngIf="invoiceDetail.zatca_enabled">
			<ng-container *ngIf="invoiceDetail.zatca_invoice; else notPushedYet">
				<div class="d-flex">
					Fatoora push status : &nbsp;&nbsp; 
					<div class="status">
						<div class="order_status order_paid">
							Pushed
						</div>
					</div>
				</div>
			</ng-container>
			<ng-template #notPushedYet>
				<div class="circle_wrapper" >
					<div class="current_plan">
						<div class="current_plan-top">
							<span><strong>What's next?</strong> Push the invoice to the Fatoora portal to generate the QR code.</span>
						</div>
					</div>
				</div>
				<button type="button" class="btn-primary" (click)="pushToFatoora()">Push to Fatoora</button>
			</ng-template>
		</div>

		<div class="new-create__preview-body">
			<div class="new-create__preview-body--header">
				<div class="preview_header_logo">
					<img src="{{ basicInfo.logo }}" alt="logo" loading="lazy">
					<div class="preview_header_name gap-3">
						<h3>
							<ng-container *ngIf="(taxAmount != 0)">
								<ng-container *ngIf="(basicInfo.country_id == COUNTRIES.SAUDI_ARABIA && invoiceDetail.invoice_type == 'b2c'); else outSideSaudi">
									<p i18n="@@invoices.simplified_tax_invoice">Simplified Tax Invoice</p>
								</ng-container>
								<ng-template #outSideSaudi>
									<p i18n="@@invoices.tax_invoice">Tax Invoice</p>
								</ng-template>
							</ng-container>
							<span>#{{ invoiceDetail.invoice_number }}</span>
							<div class="status">
								<ng-container *ngIf="invoiceDetail?.is_draft; else notDraft">
									<div class="order_status order_complete">
										<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
											<circle cx="4" cy="4" r="4" fill="#18F121"/>
										</svg>
										<ng-container i18n="@@ts.draft">Draft</ng-container>
									</div>
								</ng-container>
								<ng-template #notDraft>
									<div class="order_status order_unpaid" [ngClass]="{'order_new':(invoiceDetail.status.toLowerCase().toString() == 'paid' || invoiceDetail.status.toLowerCase().toString() == 'refund'), 'order_unpaid':(invoiceDetail.status.toLowerCase().toString() == 'unpaid' || invoiceDetail.status.toLowerCase().toString() == 'canceled'), 'order_preparing':(invoiceDetail.status.toLowerCase().toString() == 'partially' || invoiceDetail.status.toLowerCase().toString() == 'pending') }">
										<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
											<circle cx="4" cy="4" r="4" fill="#18F121"/>
										</svg>
										{{ invoiceStatus(invoiceDetail.status) }}
									</div>
								</ng-template>
							</div>
							<!-- <svg class="dots_menu" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
								<path d="M14.3999 24.3999C14.3999 23.8695 14.6106 23.3608 14.9857 22.9857C15.3608 22.6106 15.8695 22.3999 16.3999 22.3999C16.9303 22.3999 17.439 22.6106 17.8141 22.9857C18.1892 23.3608 18.3999 23.8695 18.3999 24.3999C18.3999 24.9303 18.1892 25.439 17.8141 25.8141C17.439 26.1892 16.9303 26.3999 16.3999 26.3999C15.8695 26.3999 15.3608 26.1892 14.9857 25.8141C14.6106 25.439 14.3999 24.9303 14.3999 24.3999ZM14.3999 16.3999C14.3999 15.8695 14.6106 15.3608 14.9857 14.9857C15.3608 14.6106 15.8695 14.3999 16.3999 14.3999C16.9303 14.3999 17.439 14.6106 17.8141 14.9857C18.1892 15.3608 18.3999 15.8695 18.3999 16.3999C18.3999 16.9303 18.1892 17.439 17.8141 17.8141C17.439 18.1892 16.9303 18.3999 16.3999 18.3999C15.8695 18.3999 15.3608 18.1892 14.9857 17.8141C14.6106 17.439 14.3999 16.9303 14.3999 16.3999ZM14.3999 8.3999C14.3999 7.86947 14.6106 7.36076 14.9857 6.98569C15.3608 6.61062 15.8695 6.3999 16.3999 6.3999C16.9303 6.3999 17.439 6.61062 17.8141 6.98569C18.1892 7.36076 18.3999 7.86947 18.3999 8.3999C18.3999 8.93034 18.1892 9.43904 17.8141 9.81412C17.439 10.1892 16.9303 10.3999 16.3999 10.3999C15.8695 10.3999 15.3608 10.1892 14.9857 9.81412C14.6106 9.43904 14.3999 8.93034 14.3999 8.3999Z" fill="black"/>
							</svg> -->
						</h3>
						<ng-container *ngIf="invoiceDetail.parent_invoice_id !== null">
							<span class="number" [attr.style]="'color:'+prefTextColor | safe:'style'" >
								<div class="customer_date_block">
									<span class="date" i18n="@@invoices.preview.original_invoice">Original Invoice </span>
									<a href="javascript:void(0);" class="invoice_number" (click)="viewInvoice()">#{{ invoiceDetail?.parent_invoice.invoice_number}}</a>
								</div>
							</span>
						</ng-container>
						<div class="customer_date_block">
							<span i18n="@@invoices.invoice_date">Date</span>
							<span>{{ invoiceDetail.invoice_date }} {{ invoiceDetail.invoice_time }}</span>
						</div>
					</div>
				</div>
				<div class="d-flex w-100 justify-content-end" *ngIf="invoiceDetail.status != 'canceled'">
					<button type="button" class="primary_btn" routerLink="/payments" (click)="checkReceivedPayments()" *ngIf="invoiceDetail.payments.length" i18n="@@button.check_received_payments">Check received payments</button>
					<button type="button" class="primary_btn" (click)="recordNewPayment()" *ngIf="!invoiceDetail.payments.length && (invoiceDetail.parent_invoice_id == null && invoiceDetail.status != 'paid' && invoiceDetail.is_draft != 1)" i18n="@@button.record_payment">Record payment</button>
				</div>
			</div>
			<ng-container *ngIf="invoiceDetail?.invoice_type == 'b2b'; else b2cSellerInfo">
				<div class="new-create__preview-body--details flex-row flex-none-column">
					<div class="seller_info">
						<h4 i18n="@@invoices.seller_info">Seller info</h4>
						<div class="seller_info_block">
							<div class="invoice_number">
								<span i18n="@@invoices.name">Name</span>
								<span>{{ basicInfo?.business_name | titlecase }}</span>
							</div>
							<div class="invoice_number">
								<span i18n="@@invoices.address">Address</span>
								<span>{{ basicInfo?.address }}</span>
							</div>
							<ng-container *ngIf="(invoiceDetail?.tax_type == 1 || invoiceDetail?.tax_type == 2)">
								<div class="invoice_number">
									<span i18n="@@invoices.vat_number">VAT Number</span>
									<span>{{ basicInfo?.tax_number }}</span>
								</div>
								<div class="invoice_number">
									<span i18n="@@invoices.cr_number">CR number</span>
									<span>{{ basicInfo?.cr_number }}</span>
								</div>
							</ng-container>
						</div>
					</div>
					<div class="seller_info">
						<h4 i18n="@@invoices.buyer_info">Buyer info</h4>
						<div class="seller_info_block">
							<div class="invoice_number">
								<span i18n="@@invoices.name">Name</span>
								<span>{{ invoiceDetail?.buyer_first_name }} {{ invoiceDetail?.buyer_last_name }}</span>
							</div>
							<div class="invoice_number">
								<span i18n="@@invoices.address">Address</span>
								<span>{{ invoiceDetail?.buyer_address }}</span>
							</div>
							<ng-container *ngIf="(invoiceDetail?.tax_type == 1 || invoiceDetail?.tax_type == 2)">
								<div class="invoice_number">
									<span i18n="@@invoices.vat_number">VAT Number</span>
									<span>{{ invoiceDetail?.buyer_vat_number }}</span>
								</div>
								<div class="invoice_number">
									<span i18n="@@invoices.cr_number">CR number</span>
									<span>{{ invoiceDetail?.buyer_cr_number }}</span>
								</div>
							</ng-container>
						</div>
					</div>
				</div>
			</ng-container>
			<ng-template #b2cSellerInfo>
				<div class="d-flex align-items-start justify-content-between bottom_line">
					<div class="new-create__preview-body--details">
						<div class="invoice_number">
							<span i18n="@@invoices.invoice_number">Invoice Number</span>
							<span>{{ invoiceDetail?.invoice_number }}</span>
						</div>
						<ng-container *ngIf="(invoiceDetail?.tax_type == 1 || invoiceDetail?.tax_type == 2)">
							<div class="invoice_number">
								<span i18n="@@invoices.vat_number">VAT Number</span>
								<span>{{ basicInfo?.tax_number }}</span>
							</div>
							<div class="invoice_number">
								<span i18n="@@invoices.cr_number">CR number</span>
								<span>{{ basicInfo?.cr_number }}</span>
							</div>
						</ng-container>
					</div>
					<div class="customer_name_block">
						<span i18n="@@invoices.bill_to">Bill to</span>
						<span>{{ invoiceDetail.client ? invoiceDetail.client.full_name : "Unknown Client" }}</span>
					</div>
				</div>
			</ng-template>

			<div class="d-flex gap-4 flex-none-column">
				<div class="table-wrapper w-100">
					<table class="marketing_table shadow-none-none">
						<thead>
							<tr>
								<th i18n="@@invoices.item">Item</th>
								<th i18n="@@invoices.description">Description</th>
								<th i18n="@@invoices.quantity">Quantity</th>
								<th i18n="@@invoices.unit_price">Unit Price</th>
								<th i18n="@@invoices.amount">Amount</th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngIf="invoiceDetail.items && invoiceDetail.items.length; else noItem">
								<tr *ngFor="let deliverable of invoiceDetail.items; index as $index; first as isFirst; last as isLast">
									<td data-th="Item">
										<span>{{ deliverable.title | titlecase }}</span>
										<div class="title_wrap" *ngIf="deliverable?.add_ons">
											<li class="ml-3" *ngFor="let add_on of deliverable.add_ons">{{ add_on.name | titlecase }}</li>
										</div>
										<div class="title_wrap" *ngIf="deliverable?.modifiers">
											<ng-container *ngFor="let modifierGroup of deliverable?.modifiers | keyvalue">
												<div>{{ modifierGroup.key }} -</div>
												<div class="title_wrap" *ngFor="let modEntry of modifierGroup?.value | keyvalue">
													<span class="ml-3">{{ modEntry.value.name | titlecase }}</span>
												</div>
											</ng-container>
										</div>
									</td>
									<td data-th="Description" class="description">
										<span>{{ deliverable.description | titlecase }}</span>
									</td>
									<td data-th="Quantity">
										<span>{{ deliverable?.quantity }}X</span>
									</td>
									<td data-th="Unit Price">
										<span>
											<span class="sar" [innerHtml]="invoiceDetail?.currency"></span>
											{{ deliverable.rate }}
										</span>
									</td>
									<td data-th="Amount" class="p-none-0 border-bottom-none-0">
										<span>
											<span class="sar" [innerHtml]="invoiceDetail?.currency"></span>
											{{ deliverableCost(deliverable) | number:'.2' }}
										</span>
									</td>
								</tr>
								<tr class="total-vat d-none-none" *ngIf="newTaxAmount">
									<td colspan="5" class="border-0">
										<div class="d-flex align-items-center w-100 justify-content-between">
											<ng-container i18n="@@invoices.sub_total">Sub Total</ng-container>
											<span>
												<span class="sar" [innerHtml]="invoiceDetail?.currency"></span>
												{{ newSubTotalDeliverableCost | number:'.2' }}
											</span>
										</div>
									</td>
								</tr>
								<tr class="total-vat d-none-none" *ngIf="newTaxAmount">
									<td colspan="5" class="border-0">
										<div class="d-flex align-items-center w-100 justify-content-between">
											<ng-container i18n="@@tax">Total VAT</ng-container>({{ invoiceDetail.tax_percent }}%)
											<span>
												<span class="sar" [innerHtml]="invoiceDetail?.currency"></span>
												{{ newTaxAmount | number:'.2' }}
											</span>
										</div>
									</td>
								</tr>
								<tr class="total-vat d-none-none" *ngIf="invoiceDetail.discounted_amount">
									<td colspan="5" class="border-0">
										<div class="d-flex align-items-center w-100 justify-content-between">
											<ng-container i18n="@@invoices.discount">Discount</ng-container>
											<ng-container *ngIf="invoiceDetail.discount_type == 'percentage'; else elseDiscountType">
												({{invoiceDetail.discount}}%)
											</ng-container>
											<ng-template #elseDiscountType>
												(<span class="sar" [innerHtml]="invoiceDetail?.currency"></span> {{invoiceDetail.discounted_amount | number:'.2' }})
											</ng-template>
											<span><span class="sar" [innerHtml]="invoiceDetail?.currency"></span> {{ invoiceDetail.discounted_amount | number:'.2' }}</span>
										</div>
									</td>
								</tr>
								<tr class="total-vat d-none-none" *ngIf="invoiceDetail.delivery_fee">
									<td colspan="5" class="border-0">
										<div class="d-flex align-items-center w-100 justify-content-between">
											<ng-container i18n="@@invoices.delivery_fees">Delivery Fees</ng-container>
											<span><span class="sar" [innerHtml]="invoiceDetail?.currency"></span> {{ invoiceDetail.delivery_fee | number:'.2' }}</span>
										</div>
									</td>
								</tr>
								<tr class="total-vat d-none-none" >
									<td colspan="5" class="border-0">
										<div class="d-flex align-items-center w-100 justify-content-between">
											<ng-container i18n="@@invoices.preview.total_amount">Total Due</ng-container>
											<span><span class="sar" [innerHtml]="invoiceDetail?.currency"></span> {{ invoiceDetail.total_amount | number:'.2' }}</span>
										</div>
									</td>
								</tr>
								<tr class="total-vat d-none-none" *ngFor="let payment of invoiceDetail.payments;">
									<td colspan="5">
										<div class="d-flex align-items-center w-100 justify-content-between">
											<span><ng-container i18n="@@invoices.preview.amount_paid">Amount Paid <span class="simplified-invoice__paidDate" >({{ payment.date | date:'dd/MM/yyyy' }})</span></ng-container></span>
											<span><span class="sar" [innerHtml]="invoiceDetail?.currency"></span> {{ payment.amount | number:'.2' }}</span>
										</div>
									</td>
								</tr>
								<tr class="total-due d-none-none">
									<td colspan="5">
										<div class="d-flex align-items-center w-100 justify-content-between">
											<ng-container i18n="@@invoices.preview.amount_due">Amount Due</ng-container>
											<span><span class="sar" [innerHtml]="invoiceDetail?.currency"></span> {{ invoiceDetail.due_amount | number:'.2' }}</span>
										</div>
									</td>
								</tr>
							</ng-container>
							<ng-template #noItem>
								<tr>
									<td colspan="5" class="text-center">
										<span i18n="@@invoices.no_deliverable">No deliverable</span>
									</td>
								</tr>
							</ng-template>
						</tbody>
					</table>

					<div class="total-vat2" *ngIf="newTaxAmount > 0">
						<div class="d-flex align-items-center w-100 justify-content-between">
							<ng-container i18n="@@tax">Total VAT</ng-container>({{ invoiceDetail.tax_percent }}%)
							<span><span class="sar" [innerHtml]="invoiceDetail?.currency"></span> {{ newTaxAmount | number:'.2' }}</span>
						</div>
					</div>
					<div class="total-vat2 mt-0" *ngIf="invoiceDetail.discounted_amount > 0">
						<div class="d-flex align-items-center w-100 justify-content-between">
							<ng-container i18n="@@invoices.discount">Discount</ng-container>
							<ng-container *ngIf="invoiceDetail.discount_type == 'percentage'; else elseDiscountType">
								({{invoiceDetail.discount}}%)
							</ng-container>
							<ng-template #elseDiscountType>
								({{invoiceDetail.discounted_amount | number:'.2' }}{{ invoiceDetail?.currency }})
							</ng-template>
							<span><span class="sar" [innerHtml]="invoiceDetail?.currency"></span> {{ invoiceDetail.discounted_amount | number:'.2' }}</span>
						</div>
					</div>
					<div class="total-vat2 mt-0" *ngIf="invoiceDetail.delivery_fee > 0">
						<div class="d-flex align-items-center w-100 justify-content-between">
							<ng-container i18n="@@invoices.delivery_fees">Delivery Fees</ng-container>
							<span><span class="sar" [innerHtml]="invoiceDetail?.currency"></span> {{ invoiceDetail.delivery_fee | number:'.2' }}</span>
						</div>
					</div>
					<div class="total-vat2 mt-0" *ngIf="invoiceDetail.delivery_fee > 0">
						<div class="d-flex align-items-center w-100 justify-content-between">
							<ng-container i18n="@@invoices.preview.total_amount">Total Due</ng-container>
							<span><span class="sar" [innerHtml]="invoiceDetail?.currency"></span> {{ invoiceDetail.total_amount | number:'.2' }}</span>
						</div>
					</div>
					<div class="total-vat2 mt-0" *ngFor="let payment of invoiceDetail.payments;">
						<div class="d-flex align-items-center w-100 justify-content-between">
							<span><ng-container i18n="@@invoices.preview.amount_paid">Amount Paid <span class="simplified-invoice__paidDate" >({{ payment.date | date:'dd/MM/yyyy' }})</span></ng-container></span>
							<span><span class="sar" [innerHtml]="invoiceDetail?.currency"></span> {{ payment.amount | number:'.2' }}</span>
						</div>
					</div>
					<div class="total-due2">
						<div class="d-flex align-items-center w-100 justify-content-between">
							<ng-container i18n="@@invoices.preview.amount_due">Amount Due</ng-container>
							<span><span class="sar" [innerHtml]="invoiceDetail?.currency"></span> {{ invoiceDetail.due_amount | number:'.2' }}</span>
						</div>
					</div>
				</div>

				<div class="additional_info align-items-start">
					<h4 i18n="@@invoices.additional_info">Additional Info</h4>
					<span [class.rtl]="locale == 'ar'" [class.rtl-text]="locale == 'ar'">
						<p class="pre-text">{{ invoiceDetail.additional_info }}</p>
					</span>
					<ng-container *ngIf="invoiceDetail.qr_code_base64 && (taxAmount != 0)">
						<qr-code value="{{ invoiceDetail.qr_code_base64 }}" size="150" errorCorrectionLevel="M"></qr-code>
					</ng-container>
				</div>

			</div>
		</div>
	</div>

</div>
